<span>Smart Designer</span>

<a [href]="'link.imprint' | translate" rel="noopener" target="_blank">
  {{ 'header.menu.imprint' | translate }}
</a>
<a [href]="'link.privacy_policy' | translate" rel="noopener" target="_blank">
  {{ 'globalFooter.privacy_policy' | translate }}
</a>
<a [href]="'link.wago_com' | translate" rel="noopener" target="_blank">
  wago.com
</a>
<a [href]="'link.faq_version' | translate" rel="noopener" target="_blank">
  {{ 'globalFooter.version' | translate:{'0': sdVersion} }}
</a>

<span class="flex-grow-1"></span>


@if (isProjectVersionVisible()) {
  <div class="align-items-center project-info">
    <app-svg-icon class="mx-1" [type]="projectGroupIcon()" size="medium-small"/>
    <span tooltip [tooltipText]="projectGroupName()">{{projectGroupName()}}</span>
    <app-svg-icon class="mx-2" type="caret-right" size="medium-small"/>
    <app-svg-icon class="mx-1" type="configuration" size="medium-small"/>
    <span tooltip [tooltipText]="projectName()">{{projectName()}}</span>
    <app-svg-icon class="mx-2" type="caret-right" size="medium-small"/>
    <span tooltip [tooltipText]="projectVersion()">{{ 'globalFooter.version' | translate:{'0': projectVersion()} }}</span>
    @if(articleNumberLong()) {
      <app-svg-icon class="mx-2" type="caret-right" size="medium-small"/>
      <span tooltip [tooltipText]="articleNumberLong()">{{ articleNumberLong() }}</span>
    }
  </div>
}

<span class="flex-grow-1"></span>

<span>{{ 'globalFooter.cc' | translate : {'0': year} }}</span>
